module.exports = __webpack_public_path__ + "img/announcement-img.35b92762.svg";